import React, { FC, useEffect, useState } from 'react';
import { InfoBoxProps } from '~/core/dto/components/infoBoxDTO';

import './InfoBox.styles.css';

const InfoBox: FC<InfoBoxProps> = ( { image, description, title } ) => {

  const [ descriptionLength, setDescriptionLength ] = useState( 0 );

  const updateDescription = () => {

    setDescriptionLength( ( val ) => Math.min( description.length, val + 1 ) );

    if ( descriptionLength < description.length ) {

      setTimeout( updateDescription, 50 );

    }

  };

  useEffect( () => updateDescription(), [] );

  return (
    <div className="infoBoxContainer">
      <div className="infoBoxContent hiddenContent">
        <div className="infoBoxTitle">
          <h4>{title}</h4>
          <img src={image} alt="" />
        </div>
        <p>{description}</p>
      </div>
      <div className="infoBoxContent visibleContent">
        <div className="infoBoxTitle">
          <h4>{title}</h4>
          <img src={image} alt="" />
        </div>
        <p className={descriptionLength !== description.length ? 'showCursor' : ''}>{description.substring( 0, descriptionLength )}</p>
      </div>
    </div>
  );

};

export default InfoBox;
